import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { ITransmission } from './_types';

export const getTransmissions = (transferWay: string): Promise<ITransmission[]> | false =>
  api()
    .post(`/portal-api/mdex/transfer/find?transferWay=${transferWay}`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);
